import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Tag } from 'primereact/tag';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { useGetLmsCreateRequestCommentsQuery } from '../../../../api';
import { formatDateOnly } from '../../../../utils/dateUtils';
import { REQUEST_STATUS_SEVERITY, REQUEST_STATUS_I18N_KEY } from '../utils/requestStatus';

// bkz. docs/talep_olustur_onay_akısı.md "YORUM GEÇMİŞİ" (`GET
// /v1/LmsCreateRequest/GetComments?requestId=`) — yeniden eskiye sıralı döner, `status` alanı
// yorumun hangi statü geçişinde yazıldığını gösterir.
const RequestCommentHistoryDialog = ({ visible, requestId, requestType, onHide }) => {
    const { th } = useLanguage();
    // BE requestType'ı zorunlu kılıyor (bkz. AllRequestsTab.jsx'teki not) — obje-argüman formu
    // zaten lmsCreateRequest.js'te ihale ekranı için mevcuttu, burada da aynı şekilde kullanılıyor.
    const { data, isFetching } = useGetLmsCreateRequestCommentsQuery({ requestId, requestType }, { skip: !visible || requestId == null });
    const items = Array.isArray(data) ? data : [];

    return (
        <Dialog visible={visible} onHide={onHide} header={th('trainingRequest.allRequests.history.title')} modal style={{ width: '40vw', minWidth: '380px' }}>
            {isFetching ? (
                <div className="flex justify-content-center align-items-center" style={{ minHeight: '120px' }}>
                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }} />
                </div>
            ) : items.length === 0 ? (
                <div className="text-color-secondary text-sm">{th('trainingRequest.allRequests.history.emptyMessage')}</div>
            ) : (
                <div className="flex flex-column gap-3">
                    {items.map((item) => {
                        const i18nKey = REQUEST_STATUS_I18N_KEY[item.status];
                        return (
                            <div key={item.id} className="surface-100 border-round p-3">
                                <div className="flex align-items-center justify-content-between mb-2 gap-2">
                                    <Tag value={i18nKey ? th(`trainingRequest.allRequests.statuses.${i18nKey}`) : item.status} severity={REQUEST_STATUS_SEVERITY[item.status] || 'secondary'} />
                                    <small className="text-color-secondary">{formatDateOnly(item.createdDate)}</small>
                                </div>
                                {item.comments && <div className="text-sm mb-1">{item.comments}</div>}
                                <small className="text-color-secondary">
                                    {th('trainingRequest.allRequests.history.byLabel')}: {item.createdName}
                                </small>
                            </div>
                        );
                    })}
                </div>
            )}
        </Dialog>
    );
};

export default RequestCommentHistoryDialog;
